import React, { useEffect, useState, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import Navbar from "../frontend/backend/navbar.js";
import Footer from "../frontend/backend/footer.js";
import Chatbox from "../frontend/backend/chatbox.js";
import HeaderRight from "../frontend/backend/header_right.js";
import LeftSidebar from "../frontend/backend/leftSidebar.js";
import axios from "axios";
import ReactPaginate from "react-paginate";
import styled from "styled-components";
import apiConfig from "../apiConfig";

const UserList = () => {
  let history = useHistory();

  const [data, setData] = useState([]);
  const [totalUser, setTotalUser] = useState(0);
  const [limit, setLimit] = useState(30);
  const [pageCount, setPageCount] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [searchInput, setSearchInput] = useState(""); // ✅ separate input state
  const [sortField, setSortField] = useState("currency");
  const [sortOrder, setSortOrder] = useState(-1);
  const [isLoading, setIsLoading] = useState(false);
  const currentPage = useRef(1);

  useEffect(() => {
    currentPage.current = 1;
    getPaginatedUsers();
  }, [searchQuery, limit, sortField, sortOrder]);

  const getPaginatedUsers = async () => {
    setIsLoading(true);
    try {
      const res = await fetch(
        `${apiConfig.baseURL}/api/agent/paginatedgetdataUser?page=${currentPage.current}&limit=${limit}&status=1&search=${searchQuery}&sortField=${sortField}&sortOrder=${sortOrder}`
      );
      const data = await res.json();
      setPageCount(data.pageCount);
      setTotalUser(data.totalUser);
      setData(data.result);
    } catch (err) {
      console.error("Error fetching users:", err);
    }
    setIsLoading(false);
  };

  const handleSearch = () => {
    currentPage.current = 1;
    setSearchQuery(searchInput);
  };

  const handleClearSearch = () => {
    setSearchInput('');
    setSearchQuery('');
    currentPage.current = 1;
  };

  const handleSort = (field) => {
    if (sortField === field) {
      setSortOrder(prev => prev === -1 ? 1 : -1);
    } else {
      setSortField(field);
      setSortOrder(-1);
    }
    currentPage.current = 1;
  };

  const handlePageClick = (e) => {
    currentPage.current = e.selected + 1;
    getPaginatedUsers();
  };

  const SortIcon = ({ field }) => {
    if (sortField !== field) return <span style={{ color: '#aaa', marginLeft: 4 }}>↕</span>;
    return <span style={{ marginLeft: 4 }}>{sortOrder === -1 ? '↓' : '↑'}</span>;
  };

  const MyPaginate = styled(ReactPaginate).attrs({ activeClassName: "active" })`
    margin-bottom: 2rem;
    display: flex;
    flex-direction: row;
    justify-content: center;
    list-style-type: none;
    padding: 0 2rem;
    li a {
      border-radius: 7px;
      padding: 0.1rem 1rem;
      border: gray 1px solid;
      cursor: pointer;
      margin: 0 5px;
    }
    li.active a { background-color: #0366d6; color: white; }
    li.disabled a { color: grey; }
  `;

  return (
    <>
      <Navbar /><Chatbox /><HeaderRight /><LeftSidebar />

      <div className="content-body">
        <div className="container-fluid">
          <div className="col-lg-12">
            <div className="card">

              <div className="card-header">
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-2">
                  <h4 className="card-title mb-0">
                    User List
                    <span className="badge badge-primary ms-2" style={{ fontSize: '13px' }}>
                      {totalUser} users
                    </span>
                  </h4>

                  <div className="d-flex align-items-center gap-2 flex-wrap">

                    {/* ✅ Per page selector */}
                    <select
                      className="form-control form-control-sm"
                      style={{ width: 'auto' }}
                      value={limit}
                      onChange={e => { setLimit(e.target.value); currentPage.current = 1; }}
                    >
                      <option value="30">30 / page</option>
                      <option value="100">100 / page</option>
                      <option value="200">200 / page</option>
                      <option value="500">500 / page</option>
                    </select>

                    {/* ✅ Sort field selector */}
                    <select
                      className="form-control form-control-sm"
                      style={{ width: 'auto' }}
                      value={sortField}
                      onChange={e => { setSortField(e.target.value); currentPage.current = 1; }}
                    >
                      <option value="currency">Sort: Balance</option>
                      <option value="createdAt">Sort: Date</option>
                      <option value="exposure">Sort: Exposure</option>
                    </select>

                    {/* ✅ Sort order toggle */}
                    <button
                      className="btn btn-sm btn-outline-secondary"
                      onClick={() => setSortOrder(prev => prev === -1 ? 1 : -1)}
                    >
                      {sortOrder === -1 ? '↓ Desc' : '↑ Asc'}
                    </button>

                    {/* ✅ Search input */}
                    <div className="input-group input-group-sm" style={{ width: '300px' }}>
                      <input
                        type="text"
                        placeholder="Search user_id, name, mobile, agent, ref..."
                        className="form-control"
                        value={searchInput}
                        onChange={e => setSearchInput(e.target.value)}
                        onKeyDown={e => e.key === 'Enter' && handleSearch()}
                      />
                      {searchInput && (
                        <button className="btn btn-outline-secondary" onClick={handleClearSearch}>✕</button>
                      )}
                      <button className="btn btn-primary" onClick={handleSearch}>Search</button>
                    </div>

                    <Link to="/inactive-user">
                      <button type="button" className="btn btn-sm btn-danger">Inactive</button>
                    </Link>
                  </div>
                </div>

                {/* ✅ Active search indicator */}
                {searchQuery && (
                  <div className="mt-2" style={{ fontSize: '12px', color: '#f59e0b' }}>
                    🔍 Searching: <strong>"{searchQuery}"</strong> —
                    <span className="text-muted ms-1">{totalUser} results found</span>
                    <button
                      className="btn btn-link btn-sm p-0 ms-2 text-danger"
                      onClick={handleClearSearch}
                    >
                      Clear
                    </button>
                  </div>
                )}
              </div>

              <div className="card-body">
                <div className="table-responsive">
                  {isLoading ? (
                    <div className="text-center py-4 text-muted">Loading...</div>
                  ) : (
                    <table className="table table-hover">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>User ID</th>
                          <th>Name</th>
                          <th
                            onClick={() => handleSort("currency")}
                            style={{ cursor: "pointer", whiteSpace: 'nowrap' }}
                          >
                            Balance <SortIcon field="currency" />
                          </th>
                          <th
                            onClick={() => handleSort("exposure")}
                            style={{ cursor: "pointer" }}
                          >
                            Exposure <SortIcon field="exposure" />
                          </th>
                          <th>Mobile</th>
                          <th>Agent</th>
                          <th>Referrer</th>
                          <th
                            onClick={() => handleSort("createdAt")}
                            style={{ cursor: "pointer", whiteSpace: 'nowrap' }}
                          >
                            Joined <SortIcon field="createdAt" />
                          </th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.length === 0 ? (
                          <tr>
                            <td colSpan="10" className="text-center py-4 text-muted">
                              No users found
                            </td>
                          </tr>
                        ) : (
                          data.map((element, id) => (
                            <tr key={element._id}>
                              <td className="text-muted" style={{ fontSize: '12px' }}>
                                {(currentPage.current - 1) * limit + id + 1}
                              </td>
                              <td><strong>{element.user_id}</strong></td>
                              <td>{element.first_name} {element.last_name}</td>
                              <td>
                                <span className={`badge ${parseFloat(element.currency) > 0 ? 'badge-success' : 'badge-light'}`}>
                                  ৳{parseFloat(element.currency).toFixed(2)}
                                </span>
                              </td>
                              <td>{element.exposure || 0}</td>
                              <td>{element.mobile}</td>
                              <td><small>{element.agent_id}</small></td>
                              <td><small>{element.refferer || '—'}</small></td>
                              <td style={{ fontSize: '12px', whiteSpace: 'nowrap' }}>
                                {element.createdAt
                                  ? new Date(element.createdAt).toLocaleDateString('en-GB')
                                  : '—'}
                              </td>
                              <td>
                                <div className="d-flex gap-1">
                                  <button
                                    className={`btn btn-${element.account_status === "2" ? "danger" : "success"} shadow btn-xs sharp`}
                                    onClick={async () => {
                                      const action = element.account_status === "2" ? "unblock" : "block";
                                      const res = await axios.put(`${apiConfig.baseURL}/api/agent/${action}/${element._id}`);
                                      if (res.status === 200) { getPaginatedUsers(); alert(res.data.message); }
                                    }}
                                  >
                                    <i className={`fa fa-${element.account_status === "2" ? "times" : "check"}`}></i>
                                  </button>
                                  <Link className="btn btn-primary shadow btn-xs sharp" to={`edit-user/${element._id}`}>
                                    <i className="fa fa-pencil"></i>
                                  </Link>
                                  <Link title="Bet Summary" className="btn btn-info shadow btn-xs sharp" to={`bet-summery/${element._id}`}>
                                    <i className="fa fa-clipboard"></i>
                                  </Link>
                                 
                                  <Link title="Deposit Summary" className="btn btn-primary shadow btn-xs sharp" to={`daily-deposit-sorting?user_id=${element.user_id}`}>
                                    <i className="fa fa-bar-chart"></i>
                                  </Link>
                                  <Link title="Withdraw Summary" className="btn btn-danger shadow btn-xs sharp" to={`daily-withdraw-sorting?user_id=${element.user_id}`}>
                                    <i className="fa fa-usd"></i>
                                  </Link>
                                  <Link
                                      title="lucky exchange report"
                                      className="edit-link btn btn-warning shadow btn-xs sharp me-1"
                                      to={`exchange-summery/${element._id}`}
                                    >
                                      <i className="fa fa-bolt"> </i>
                                    </Link>
                                </div>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  )}

                  <MyPaginate
                    breakLabel="..."
                    nextLabel="next >"
                    onPageChange={handlePageClick}
                    pageRangeDisplayed={5}
                    pageCount={pageCount}
                    previousLabel="< previous"
                    marginPagesDisplayed={2}
                    containerClassName="pagination justify-content-center"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    activeClassName="active"
                    forcePage={currentPage.current - 1}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default UserList;